<template>
  <div id="content" class="content">
    <ul class="p_list">
      <li class="li_two" v-for="(item, index) in tDatas" :key="index" data-id="item.id" data-catid="item.catid" v-if="item != null">
        <a :href="'./details.html?id='+item.id" class="img_wrapper"><img :src="item.thumb_guid" alt="" /></a>
        <div class="project_text">
          <p class="project_title_en">{{item.thumb_title_en}}</p>
          <p>{{item.thumb_title}}&nbsp;&nbsp;{{item.icname}}</p>
        </div>
      </li>
    </ul>

    <div v-if="(hDatas && hDatas.length > 0) || (nds && nds.length > 0)">
      <ul class="p_list">
        <li class="li_four" v-for="(item, index) in hDatas" :key="index" :data-id="item.id">
          <a :href="'./details.html?id='+item.id" class="img_wrapper" :style="'background-image: url('+item.thumb_guid+');'"><img :src="item.thumb_guid" alt="" /></a>
          <div class="project_text">
            <p class="project_title_en">{{item.post_title_en}}{{item.thumb_title_en}}</p>
            <p>{{item.post_title}}&nbsp;&nbsp;{{item.icname}}</p>
            <!-- <p class="project_title_en">{{item.thumb_title_en}}</p>
            <p>{{item.post_title}}&nbsp;&nbsp;{{item.icname}}</p> -->
          </div>
        </li>
        <li class="li_four" v-else></li>
      </ul>

      <div class="p_list" v-if="tln == 'news'">
        <dl class="page_list" v-for="(item, index) in nds" :key="index">
          <dt class="pl_title">
            <p><span>{{item.post_date}}</span></p>
          </dt>
          <dd class="pl_content">
            <div class="plc_title">
              <p class="pt_en"><span>{{item.post_en_post_title}}</span></p>
              <p class="pt_cn"><span>{{item.post_title}}</span></p>
            </div>
            <img :src="item.thumb_guid" alt="" />
            <div class="plc_content" v-html="item.post_content"></div>
          </dd>
        </dl>
      </div>
    </div>
    <div v-else class="loading"><img src="../../assets/images/loading.gif" alt=""></div>


    <h1 class="project_more" v-if="tln == 'news'">VIEW ALL NEWS</h1>
    <h1 class="project_more" v-else>VIEW ALL WORKS</h1>
  </div>
</template>

<script>
  export default {
    name: "Content",
    props: ["tDatas", "hDatas", "aDatas", "tln", "nds"],
    data: function() {
      return {

      }
    },
    mounted:function(){

    },
    watch: {
      hDatas: function(value) {
        this.hDatas = this.supplementArray(this.hDatas);
      }
    },
    methods: {
      filterData: function(value) {
        if(value.length > 0) {
          let tempAllDatas = [];
          if(value == 'all') {
            tempAllDatas = this.aDatas;
          }else {
            for(let i = 0; i < this.aDatas.length; i++) {
              if(this.aDatas[i].cid == value) {
                tempAllDatas.push(this.aDatas[i]);
              }
            }
          }
          this.hDatas = this.supplementArray(tempAllDatas);
        }
      },
      supplementArray: function(arr) {
        if(arr.length > 0) {
          let sNum = arr.length % 4;
          for(let i = 0; i < sNum; i++) {
            arr.push({});
          }
        }
        return arr;
      }
    }
  }
</script>

<style lang="less">
  .content {
    padding-top: 8.438em;
    .p_list {
      display: flex;
      justify-content: space-between;
      align-items: space-between;
      flex-wrap: wrap;
      margin: 0;
      .li_two {
        width: 49.730%;
        .img_wrapper {
          height: 20.593vw;
        }
      }
      .li_four {
        width: 24.595%;
        .img_wrapper {
          height: 13.021vw;
          background-repeat: no-repeat;
          background-size: auto 100%;
          background-position: left center;
          transition: background-size 0.2s ease-in-out;
        }
      }
      li {
        .img_wrapper {
          display: block;
          width: 100%;
          overflow: hidden;
          img {
            /* transition: height 0.2s ease; */
          }
          &:hover {
            background-size: auto 112%;
            img {
              display: none;
              /* height: 112%; */
            }
          }
        }
        img {
          display: block;
          height: 102%;
        }
        .project_text {
          font-size: 0.75em;
          height: 4vw;
          margin: 0.833em 0 0 0;
          line-height: 1;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          overflow: hidden;
          p {
            margin: 0;
          }
          .project_title_en {
            font-family: "ULTS";
            letter-spacing: normal;
            word-break: normal;
            width: 90%;
            margin-bottom: 0.667em;
          }
        }
      }
    }

    .page_list {
      width: 100%;
      display: flex;
      justify-content: space-between;
      padding: 4.167em 0 5.208vw 0;
      border-bottom: solid thin black;
      &:first-child {
        margin-top: -8em;
      }
      &:last-child {
        border-bottom: none;
        padding: 4.167em 0 0 0;
      }
      .pl_title {
        font-size: 1.125em;
        font-weight: bold;
        width: 24.009vw;
        p {
          margin: 0;
          span {
            border-bottom: solid thin black;
          }
        }
      }
      .pl_content {
        font-size: 0.875em;
        width: 53.074vw;
        figure {
          width: 100%;
          margin: 0;
          padding-bottom: 2.083vw;
          img {
            width: 100%;
          }
          figcaption {
            display: none;
          }
        }
        p {
          strong {
            margin-right: 2em;
          }
        }
        img {
          width: 100%;
        }
        .plc_title {
          font-size: 1.286em;
          font-weight: bold;
          line-height: 1.536;
          margin-bottom: 4.167vw;
          .pt_en {
            width: 48%;
            word-break: keep-all;
          }
          .pt_cn {
            font-size: 2.778em;
          }
          p {
            margin: 0;
          }
        }
        .plc_content {
          font-size: 0.875em;
        }
      }
    }

    .loading {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      img {
        width: 22em;
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/common/Content.vue